import { PARTNERS } from "@/lib/data";
import { Reveal, Overline } from "@/components/Reveal";
import { useLang } from "@/i18n";
import { ArrowUpRight } from "lucide-react";

/** Partner logos rendered as clean wordmarks; real partners link out. */
const PartnersGrid = ({ heading = true }) => {
  const { t } = useLang();

  return (
    <section id="partners" data-testid="partners-section" className="py-8">
      <div className="w-full max-w-[1440px] mx-auto px-6 md:px-12">
        {heading && (
          <Reveal>
            <Overline>{t("partnersGrid.overline")}</Overline>
            <p className="mt-4 text-2xl md:text-3xl font-display font-bold text-[#1d3a1f]/70 max-w-2xl">
              {t("partnersGrid.heading")}
            </p>
          </Reveal>
        )}
        <div className={`grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 ${heading ? "mt-14" : ""}`}>
          {PARTNERS.map((p, i) => {
            const Tag = p.url ? "a" : "div";
            const linkProps = p.url ? { href: p.url, target: "_blank", rel: "noopener noreferrer" } : {};
            return (
              <Reveal key={p.name} delay={i * 0.08}>
                <Tag {...linkProps} data-testid={`partner-${p.short.toLowerCase()}`}
                  className="group relative flex flex-col items-center justify-center h-44 rounded-2xl border border-[#1d3a1f]/10 card-soft hover:border-[#d3a53a] hover:-translate-y-1.5 hover:shadow-xl transition-all duration-300">
                  <span className="font-display font-extrabold text-3xl md:text-4xl tracking-tight text-[#1d3a1f]/35 group-hover:text-[#1d3a1f] transition-colors duration-300">{p.name}</span>
                  {p.url && (
                    <span className="mt-3 inline-flex items-center gap-1 text-xs font-bold tracking-[0.15em] uppercase text-[#5f6b57] opacity-0 group-hover:opacity-100 group-hover:text-[#d3a53a] transition-all duration-300">
                      {t("partnersGrid.visit")} <ArrowUpRight size={13} />
                    </span>
                  )}
                </Tag>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default PartnersGrid;
